import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "../../lib/CustomButton";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  text: string;
  disabled?: boolean;
  isTopWinner?: boolean;
  isProductBox?: boolean;
  /** Sold out variant: stays visible, but is marked and (usually) not selectable. */
  outOfStock?: boolean;
  /** Sold out, yet still selectable so the shopper can request a restock reminder. */
  allowSelectOutOfStock?: boolean;
}

const ButtonOption: React.FC<Props> = ({
  selected,
  toggleOption,
  text,
  disabled = false,
  isTopWinner = false,
  isProductBox,
  outOfStock,
  allowSelectOutOfStock,
}) => {
  const selectable = !disabled || !!allowSelectOutOfStock;
  const outOfStockClassName = outOfStock ? "option-out-of-stock" : "";
  return isProductBox ? (
    <CustomButton
      type={selected ? BtnTypes.secondary : BtnTypes.neutral}
      size={BtnSizes.option}
      radius={BtnRadius.semi_small}
      disabled={disabled || outOfStock}
      notAllowed={!selectable}
      onClick={selectable ? toggleOption : undefined}
      style={isProductBox ? { height: 16 } : undefined}
      className={outOfStockClassName}
    >
      {text}
    </CustomButton>
  ) : (
    <CustomButton
      type={
        selected
          ? BtnTypes.primary
          : isTopWinner
          ? BtnTypes.secondary_no_border
          : BtnTypes.secondary
      }
      size={BtnSizes.option}
      radius={isTopWinner ? BtnRadius.medium : BtnRadius.small}
      disabled={disabled || outOfStock}
      notAllowed={!selectable}
      onClick={selectable ? toggleOption : undefined}
      className={outOfStockClassName}
    >
      {text}
    </CustomButton>
  );
};

export default ButtonOption;
